import React, {Component} from 'react';
require(`../assets/${process.env.PAGE}/css/components/require-loan-button.css`);

class MainForm extends Component {
    constructor(props){
        super(props);
        this.scrollToTop.bind(this);
    }


    scrollToTop() {
        window.scrollTo(0, 0);
    }

    render() {
        return (
                <button type="submit" onClick={ this.scrollToTop } className="puedo-button puedo-button-anchor" >Enviá tu solicitud</button>
            );
    };
}

export default MainForm;


/** WEBPACK FOOTER **
 ** ./src/components/RequireLoanButton.js
 **/